import { AbandonedCardRules } from "./abandoned-card-rules.abstract";

export class BaskRulesService extends AbandonedCardRules {
  abandonedIcon = "/assets/images/bask/time-expiration-icon.svg";
}
